/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_Assistant9Inputs */

const cs_role_assistant9 = /** @type {(inputs: Role_Assistant9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistent`)
};

const en_role_assistant9 = /** @type {(inputs: Role_Assistant9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistant`)
};

/**
* | output |
* | --- |
* | "Assistant" |
*
* @param {Role_Assistant9Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
const role_assistant9 = /** @type {((inputs?: Role_Assistant9Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_Assistant9Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_assistant9(inputs)
	return cs_role_assistant9(inputs)
});
export { role_assistant9 as "role_ASSISTANT" }